<template>
  <div class="empty-dashboard">
    <div class="empty-dashboard__header">
      {{emptyMessage}}
    </div>
    <div v-if="message" class="empty-dashboard__message">
      {{message}}
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    emptyMessage: {
      type: String,
      default: 'There are no Rows to Display'
    },
    message: String
  }
}

</script>

<style lang="scss">

.empty-dashboard {
  color: color('blues', 'darker');
  height: 100%;
  width: 100%;
  // TODO needs to be the same as the color scheme

  &__header {
    padding-top: 237px;
    text-align: center;
    font-size: 36px;
    line-height: 36px;
    font-weight: bold;
  }

  &__message {
    margin-top: 12px;
    text-align: center;
    font-size: 17px;
    line-height: 24px;
  }
}

</style>



// WEBPACK FOOTER //
// EmptyTable.vue?5733ed52